// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__LqDBz","open":"Nav_open__ZygWM","FooterLinks":"Nav_FooterLinks__EwNGr","links":"Nav_links__goQA5"};